import ItemLevelListViewModel from "../view/itemlevellistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedItemLevels extends PagedElements<ItemLevelListViewModel> {
    constructor(init?: Partial<PagedItemLevels>) { super(init); }
}